import { IconButton, InputBase, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./SearchInput.scss";

const SearchInput = (props?: any) => {
  const { handleChange } = props;
  return (
    <Paper className="search-input center">
      <IconButton type="button" aria-label="search" style={{ padding: "0" }}>
        <SearchIcon style={{ fontSize: "20px" }} />
      </IconButton>
      <InputBase
        sx={{ ml: 1, flex: 1,fontSize: '0.7rem'}}
        placeholder={props.placeholder || props.placeHolder}
        style={{ paddingLeft: "0", marginLeft: "0" }}
        onChange={handleChange}
        onKeyUp={props.onKeyUp}
      />
    </Paper>
  );
};

export default SearchInput;
